/* eslint-disable no-param-reassign */
import { produce } from 'immer';
import { UPDATE_CLIENT, UPDATE_VEHICLE, UPDATE_EXTRA, NEW_TRANSACTION, SET_FORM_FIELDS } from 'actions/transaction';

let initialState = {
  client: {
    client_mail: '',
    name: '',
    surname: '',
    is_client: '',
    rut: '',
    client_model_id: '',
    vehicle_status: '',
    funding: '',
    funding_file: '',
    funding_identifier: '',
    desired_model_comments: '',
    brand: '',
    phone: '',
    mobile: '',
    office_phone: '',
    client_present: false,
    renewal: '',
    purchase_type: '',
    origin_name: '',
    heavy_vehicle: false,
    vehicle_has_stock: '',
    city: ''
  },
  vehicle: {
    license_plate: '',
    brand: '',
    model_id: '',
    model_year: '',
    year: '',
    version_id: '',
    km: '',
    fuel_type: '',
    traction: '',
    cylinder_capacity: '',
    transmission: '',
    custom_version: '',
    custom_version_number: '',
    custom_version_comment: '',
    branch_id: '',
    subversion: '',
    heavy_vehicle: false
  },
  extra: {
    steering: '',
    color: '',
    doors_number: '',
    owners_number: '',
    seat_runs: '',
    tapestry: '',
    rims: '',
    air_conditioner: '',
    sun_roof: '',
    central_lock: '',
    alarm: '',
    airbags_number: '',
    abs: '',
    circulation_permit: '',
    inspection: '',
    checkup: '',
    zofri:'',
    billable:'',
    collateral: '',
    soat: '',
    gas_convertion: '',
    key_spare: '',
    options_condition: '3',
    comment: '',
    type: ''
  },

  vehicle_brands: [],
  vehicle_models: [],
  vehicle_versions: [],
  vehicle_subversions: [],
  vehicle_years: [],
  client_brands: [],
  client_models: [],
  form_fields: [],
  branches: [],
  transactions: [],
  client_number_phones: 1,
  hide_form_fields: [],
  purchase_types: {},
  cities: []
};

const transactionReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case UPDATE_CLIENT: {
      const { brands, models, values, numberPhones } = action.payload;
      return produce(state, draft => {
        draft.client = values;
        draft.client_brands = brands;
        draft.client_models = models;
        draft.client_number_phones = numberPhones;
      });
    }
    case UPDATE_VEHICLE: {
      const { brands, models, versions, subversions, values, color, years } = action.payload;
      return produce(state, draft => {
        draft.vehicle = values;
        draft.vehicle_brands = brands;
        draft.vehicle_models = models;
        draft.vehicle_versions = versions;
        draft.vehicle_subversions = subversions;
        draft.vehicle_years = years;
        draft.extra.color = color;
      });
    }
    case UPDATE_EXTRA: {
      const values = action.payload;
      return produce(state, draft => {
        draft.extra = values;
      });
    }
    case NEW_TRANSACTION: {
      const { form_fields, branches, hide_form_fields, purchase_types, cities } = action.payload;
      return produce(state, draft => {
        // draft = initialState;
        draft.form_fields = form_fields;
        draft.branches = branches;
        draft.hide_form_fields = hide_form_fields;
        draft.purchase_types = purchase_types;
        draft.cities = cities;
      });
    }
    case SET_FORM_FIELDS: {
      const { form_fields } = action.payload;
      return produce(state, draft => {
        draft.form_fields = form_fields;
      });
    }

    default: {
      return state;
    }
  }
};

export default transactionReducer;
